import { render, staticRenderFns } from "./CardUpdatableProductCategory.vue?vue&type=template&id=6f46e0ce&scoped=true&"
import script from "./CardUpdatableProductCategory.vue?vue&type=script&lang=js&"
export * from "./CardUpdatableProductCategory.vue?vue&type=script&lang=js&"
import style0 from "./CardUpdatableProductCategory.vue?vue&type=style&index=0&id=6f46e0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f46e0ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VChip,VCol,VContainer,VDialog,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VSwitch,VTextField})
